/** Relative links in the markdown (`./assets/x.webp`, `../production/assets/y.webp`) resolve against the topic's assets URL on the API. */
export const resolveHelpTopicImageSrc = ({
  src,
  markdownBasePath,
}: {
  src: string;
  markdownBasePath: string;
}): string => {
  if (
    !src ||
    src.includes("://") ||
    src.startsWith("data:") ||
    src.startsWith("/")
  ) {
    return src;
  }

  const normalizedBase = markdownBasePath.replace(/\/$/, "");
  const cleanSrc = src.replace(/^\.\//, "");

  return `${normalizedBase}/${cleanSrc}`;
};
